import moment from 'moment';
import { AngularInjector } from '../angular';

import { type IConfigurationService } from 'components/system/configuration/types/IConfigurationService';

export class DateTime {
    private static _instance = new DateTime();

    public static getInstance() {
        return DateTime._instance;
    }

    public get format(): { date: string; time: string } {
        const configuration: IConfigurationService = AngularInjector.get<IConfigurationService>('configuration');

        return {
            date: configuration.getDateFormatForDateTimeSystemService(),
            time: configuration.getTimeFormatForDateTimeSystemService()
        };
    }

    public dayMonthFormat(day: number, month: number) {
        let format = this.format.date;

        format = format.replace('YYYY', ''); // YYYY-MM-DD to -MM-DD | DD-YYYY-MM to DD--MM | DD-MM-YYYY to DD-MM-
        format = format.replace(/(^[^MD])|([^MD]$)/, ''); // -MM-DD to MM-DD | DD--MM to DD--MM | DD-MM- to DD-MM
        format = format.replace(/([^MD])([^MD]*)/, '$1'); // DD--MM to DD-MM

        const anyLeapYearNumber = 1900; // leap year to prevent 29/02 potential side effects
        const momentObject = moment(day + '-' + month + '-' + anyLeapYearNumber, 'DD-MM-YYYY');
        return momentObject.format(format);
    }

    public parseDate(string, format = this.format.date, strict = true) {
        const ret = moment(string, format, strict);
        //        console.log('parseDate string', string, 'format', format, 'valid', ret.isValid());
        return ret;
    }

    public parseTime(string, format = this.format.time, strict = true) {
        return moment(string, format, strict);
    }

    public parseDateTime(string, format = `${this.format.date} ${this.format.time}`, strict = true) {
        return moment(string, format, strict);
    }

    public momentFormat(momentObject, format = this.format.date) {
        const ret = momentObject.format(format);
        //        console.log('momentFormat', format, momentObject.toDate(), ret);
        return ret;
    }

    public static fromDate(date: number | string = Date.now()) {
        return moment(date);
    }

    public static toDate(momentObject) {
        return momentObject.toDate();
    }
    /*
    private _formats = {
        'en_US': {date: 'MM/DD/YYYY', time: 'hh:mm a'},
        'fr_FR': {date: 'DD/MM/YYYY', time: 'HH:mm'},
        'de_DE': {date: 'DD.MM.YYYY', time: 'HH:mm'}
    };
*/
}
